export const FILTER_FIELD_TYPES = {
  SELECT: 'select',           // single-value <select>
  MULTI_SELECT: 'multi_select', // multi-value dropdown (MUI)
  TEXT: 'text',               // free text input
  DATE: 'date',               // single date picker
  DATE_RANGE: 'date_range',   // from/to date range
  ENUM: 'enum',               // fixed set of string options (e.g. Yes/No/All)
  CUSTOM: 'custom',           // render prop – caller supplies the component
};